<div class="basin-pb-4 basin-width-100 ">
  <div class="basin-font-primary basin-mb-3">
 <p>
       Your study area size: 
    <span class="basin-font-secondary highlight-selected-area-label-text basin-font-weight-700">
      {{ currentStudyArea }} sq km</span>. 
    </p>
    <p *ngIf="remainingLicenseArea !== '-1'">     
      Area remaining in your license tier:
      <span class="basin-font-secondary highlight-remaining-area-label-text basin-font-weight-700">
        {{ remainingLicenseArea }} sq km</span>.
    </p>
    
  </div>
  <div></div>
  <div class="basin-p-1 space-textbox-top">
    <form [formGroup]="form" class="form-container basin-display-flex basin-gap-2 textbox-space">
      <formly-form [form]="form" [fields]="studyAreaNameFields" [model]="model" [options]="options"></formly-form>
    </form>
  </div>
</div>
<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button pButton styleClass="p-button-outlined" type="button" (click)="onCancel()" label="Cancel"
    class="p-button-text height-2 basin-mr-6">
  </button>

  <button pButton type="submit" [disabled]="!form.valid" (click)="onContinue()" class="p-button-text" label="Continue">
  </button>
</div>